import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { planMutationKeys } from '../constants'

export const useCheckPlanChildrenNameIsAvailableMutation = (options) => {
  const handleMutation = async ({
    destinationFolderId = null,
    selectedItemNames
  }) => {
    const config = {
      method: 'post',
      data: selectedItemNames
    }

    const { data } = await api(
      `/api/v2/planFolders/${destinationFolderId}/childrenNames`,
      config
    )

    return data
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: [planMutationKeys.CHECK_CHILDREN_NAME_IS_AVAILABLE],
    retry: 0,
    ...options,
    onSuccess: (data, variables, context) => {
      return options?.onSuccess?.(data, variables, context)
    },
    onError: (error, variables, context) => {
      return options?.onError?.(error, variables, context)
    }
  })
}
